<template>
  <div id="PlatCardGroup">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>月车</el-breadcrumb-item>
          <el-breadcrumb-item>复旦月卡管理</el-breadcrumb-item>
          <el-breadcrumb-item>月卡分组管理</el-breadcrumb-item>
          <el-breadcrumb-item>月卡分组列表</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="pageSearch">
        <el-form-item label="关键字::">
          <el-input placeholder="请输入平台分组名称"
                    v-model="searchKeyWord"
                    class="input-with-select">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     @click="cardQuery">查询</el-button>
          <el-button type="success"
                     size="small"
                     icon="el-icon-share"
                     :loading="export_loading"
                     v-if="is_export"
                     @click="exportData">{{export_msg}}</el-button>
        </el-form-item>
        <el-form-item style="float:right;margin-right:0px;">
          <el-button type="primary"
                     size="small"
                     @click="addSyncPlatCardGroup"
                     v-if="is_edit">新增分组</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-tabs v-model="cardActiveName"
               type="card"
               @tab-click="tabClick">
          <el-row>
            <el-table :data="cardList"
                      border
                      v-loading="loading"
                      highlight-current-row
                      style="width: 100%"
                      :height="tableHeight"
                      ref="singleTable">
              <el-table-column type="index"
                               width="50"
                               label="序号"
                               :index="indexMethod">
              </el-table-column>
              <el-table-column prop="fOpLastTime"
                               width="180"
                               label="最后同步时间">
              </el-table-column>
              <el-table-column prop="fPlatGrpName"
                               label="平台分组名称">
              </el-table-column>
              <el-table-column prop="fIsSyncDataName"
                               label="同步状态">
              </el-table-column>
              <el-table-column prop="fRemark"
                               label="备注信息">
              </el-table-column>
              <el-table-column fixed="right"
                               align="center"
                               label="操作"
                               width="280">
                <template slot-scope="scope">
                  <el-button @click="viewCard(scope.row)"
                             type="success"
                             size="mini">查看</el-button>
                  <el-button size="mini"
                             type="warning"
                             @click="editPlatCardGroup(scope.$index, scope.row)"
                             v-if="is_edit">编辑</el-button>
                  <el-button size="mini"
                             type="danger"
                             @click="deletePlatCardGroupBut(scope.$index, scope.row)"
                             v-if="is_del">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
      </el-tabs>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageNo"
                         @current-change="handlePage"
                         :page-size="pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div class="userGroupEdit">
            <el-dialog :title="platCardGroup.operateFlag"
                       v-dialogDrag
                       :visible.sync="dialogGroupFormVisible"
                       top="20vh"
                       left="0vh"
                       width="40%">
              <el-form :model="platCardGroup"
                       :rules="groupRules"
                       ref="platCardGroupForm"
                       label-width="180px">
                <el-row style="padding-top:10px;padding-right:10px">
                  <el-col :span="12">
                    <el-form-item label="平台分组名称::" prop="fPlatGrpName">
                      <el-input v-model="platCardGroup.fPlatGrpName"
                                :disabled="!groupIsEdit"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row style="padding-right:10px">
                  <el-col :span="24">
                    <el-form-item label="备注信息::" prop="fRemark">
                      <el-input v-model="platCardGroup.fRemark"
                                type="textarea"
                                style="width: 100%"
                                :disabled="!groupIsEdit"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <div slot="footer"
                   class="dialog-footer">
                <el-button type="primary"
                          :loading="save_loading"
                           @click="submitForm('platCardGroupForm')"
                           v-if="groupIsEdit">{{save_msg}}</el-button>
                <el-button @click="dialogGroupFormVisible = false">取消</el-button>
              </div>
            </el-dialog>
          </div>
    <carInfoView ref="child"
                 reportActiveName="cardList"
                 :type="2"></carInfoView>
  </div>
</template>

<script>
import carInfoView from '../../components/carInfoView'
import { mapActions } from 'vuex'
export default {
  components: { carInfoView },
  name: 'PlatCardGroup',
  data () {
    return {
      save_loading: false,
      save_msg: '保存',
      save_msgs: '保存',
      is_edit: false,
      is_del: false,
      is_export: false,
      export_msg: '导出',
      export_loading: false,
      cardActiveName: 'cardList',
      loading: false,
      searchKeyWord: '',
      searchInOutKeyWord: '',
      searchReaKeyWord: '',
      tableHeight: 0,
      tableDetailHeight: 0,
      choiceCusts: [],
      offlineCusts: [],
      choiceGroups: [],
      cardList: [],
      selCustID: '',
      fGrpID: '',
      selfGroupID: '',
      pageSize: 20,
      pageNo: 1,
      total: 0,
      platCardGroup: {
        fPlatGrpID: 0,
        edit: false,
        fPlatGrpName: '',
        fRemark: ''
      },
      groupRules: {
        fPlatGrpName: [
          { required: true, message: '请输入平台分组名称', trigger: 'change' }
        ]
      },
      groupIsEdit: false,
      groupIsEdits: false,
      dialogGroupFormVisible: false
    }
  },
  methods: {
    ...mapActions([
      'getCardGroupByCustId', 'getCustByGroup', 'getPlatCardGroupListAsync', 'deletePlatCardGroup', 'savePlatCardGroup', 'getEhallCardFillDurationList', 'getGroupCust', 'getCardByQuery', 'loadCardOtherList', 'getParkList', 'saveCard', 'getCurrentUserPers'
    ]),
    uploadSuccess (response, file, fileList) {
      console.log('file upload success')
    },
    exportData () {
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.choiceCusts || []).filter((item) => {
        return item.fCustID === this.selCustID
      })
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      this.getPlatCardGroupListAsync({
        fCustID: this.selCustID,
        fGroupID: this.selfGroupID,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        searchKeyWord: this.searchKeyWord,
        exportData: 1
      }).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_平台月卡分组数据.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    handleInfo (row) {
      this.r = {
        isOld: false,
        tyPe: 2,
        isSync: false,
        id: row.fBusID,
        fBusID: row.fBusID,
        fCustID: row.fCustID
      }
      this.$refs.child.handleInfo(this.r)
    },
    tabClick () {
      this.pageNo = 1
      this.total = 0
      this.initData()
    },
    cardQuery () {
      this.initData()
      // let obj = {}
      // obj = this.choiceCusts.find((item) => {
      //   return item.fCustID === this.selCustID
      // })
      // this.custName = obj.unionName
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save_loading = true
          this.save_msg = '保存中…'
          this.savePlatCardGroup(this.platCardGroup).then(res => {
            this.save_loading = false
            this.save_msg = '保存'
            if (res && res.data) {
              var data = res.data
              if (data.IsOk) {
                this.dialogGroupFormVisible = false
                this.initData()
                this.$message.success('分组数据保存成功')
              } else {
                this.$message.error(data.Msg)
              }
            }
          })
        }
      })
    },
    addSyncPlatCardGroup () {
      setTimeout(() => {
        if (this.$refs['platCardGroupForm']) {
          this.$refs['platCardGroupForm'].clearValidate()
        }
      }, 50)
      this.groupIsEdit = true
      this.groupIsEdits = true
      this.platCardGroup = {
        edit: false,
        operateFlag: '新增分组',
        fPlatGrpID: 0,
        fPlatGrpName: '',
        fRemark: ''
      }
      this.dialogGroupFormVisible = true
    },
    editPlatCardGroup (index, row) {
      setTimeout(() => {
        if (this.$refs['platCardGroupForm']) {
          this.$refs['platCardGroupForm'].clearValidate()
        }
      }, 50)
      this.platCardGroup = {}
      this.platCardGroup = row
      this.platCardGroup.edit = true
      this.groupIsEdit = true
      this.groupIsEdits = false
      this.platCardGroup.operateFlag = '编辑月卡分组'
      this.platCardGroup.fPlatGrpID = row.fPlatGrpID
      this.dialogGroupFormVisible = true
    },
    viewCard (row) {
      setTimeout(() => {
        if (this.$refs['platCardGroupForm']) {
          this.$refs['platCardGroupForm'].clearValidate()
        }
      }, 50)
      this.platCardGroup = {}
      this.platCardGroup = row
      this.groupIsEdit = false
      this.groupIsEdits = false
      this.platCardGroup.operateFlag = '查看月卡分组'
      this.platCardGroup.fCarTypeID = '1'
      this.platCardGroup.fBatStartTime = row.fBatStartTimeTitle
      this.platCardGroup.fBatEndTime = row.fBatEndTimeTitle
      this.dialogGroupFormVisible = true
    },
    deletePlatCardGroupBut (index, row) {
      this.$confirm('删除分组【' + row.fPlatGrpName + '】记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deletePlatCardGroup({ fPlatGrpID: row.fPlatGrpID }).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.$message.success('分组数据删除成功')
              this.initData()
            } else {
              this.$message.error(data.Msg)
            }
          }
        })
      })
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
    },
    setDetailTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 560
      obj.tableDetailHeight = clientHeight
    },
    indexMethod (index) {
      return this.pageSize * (this.pageNo - 1) + index + 1
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageNo = index
      this.initData()
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fIsDel === '1') {
        return 'warning-row'
      }
      return ''
    },
    tableErrorRowClassName ({ row, rowIndex }) {
      if (row.fIsErr) {
        return 'error-row'
      }
      return ''
    },
    initData () {
      this.cardList = []
      this.loading = true
      this.getPlatCardGroupListAsync({
        fCustID: this.selCustID,
        fGroupID: this.selfGroupID,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        searchKeyWord: this.searchKeyWord,
        cardActiveName: this.cardActiveName,
        exportData: 0
      }).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.total = data.Data.total
              this.cardList = data.Data.rows
            } else {
              this.$message.error(data.Msg)
            }
          }
        }
      })
    },
    changeCust (fCustID) {
      this.selfGroupID = ''
      this.choiceGroups = []
      this.getCardGroupByCustId({ fCustID: fCustID }).then(res => {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let tmpGroups = []
            Object.assign(tmpGroups, data.Data)
            this.choiceGroups = tmpGroups
          }
        }
      })
    }
  },

  watch: {

  },
  computed: {
    ispagination: function () {
      return this.total > this.pageSize
    }
  },
  created () {
    this.getCurrentUserPers({ perTypeId: 1039100 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
      this.setDetailTableHeight(sizethis)
    }
    this.getCustByGroup().then(res => {
      if (res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
            if (this.choiceCusts && this.choiceCusts.length === 1) {
              this.selCustID = this.choiceCusts[0].fCustID
              this.fGrpID = this.choiceCusts[0].fGrpID
              this.changeCust(this.selCustID)
            }
            this.offlineCusts = custs.filter(r => r.fCustTypeID === '0') // 封闭式客户
          }
        }
      }
    })
    this.initData()
  },
  updated () {
    this.setTableHeight(this)
    this.setDetailTableHeight(this)
  }
}
</script>

<style>
#PlatCardGroup .is-disabled .el-input__inner,
#PlatCardGroup .is-disabled .el-textarea__inner {
  color: #606266;
}
#PlatCardGroup .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#PlatCardGroup .el-dialog__title {
  color: white;
}
#PlatCardGroup .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#PlatCardGroup .el-dialog__body {
  padding: 5px;
}
#PlatCardGroup .warning-row {
  color: chocolate;
}
#PlatCardGroup .error-row {
  color: #fb4545;
}
</style>
<style scoped>
.myCardLableClass .isRed {
  color: #fb4545;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
.curRowInfo {
  margin-top: 10px;
}
.curRowInfo .el-row {
  margin-top: 10px;
}
.dialog-video-wrapper .el-dialog__body {
  padding: 5px;
}
.myel-input__inner {
  height: 20px;
  line-height: 20px;
}
legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 10px;
  line-height: inherit;
  color: #333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
}
fieldset {
  margin: 0 2px;
  border: 0px solid silver;
}
.el-upload__tip {
  margin-top: 0px;
  color: red;
}
.userGroupEdit .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
.userGroupEdit .el-dialog__title {
  color: white;
}
.userGroupEdit .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
.userGroupEdit .el-dialog__body {
  padding-top: 20px;
  padding-left: 20px;
  padding-left: 20px;
  padding-bottom: 0px;
}
#PlatCardGroup .userGroupEdit .el-tabs__content {
  height: 400px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/view/card/PlatCardGroup.vue